<svg xmlns="http://www.w3.org/2000/svg" viewBox="-90 -25 1741 390" [attr.automation-id]="'panaya-logo'" class="logo">
    <g class="cls-1">
        <g id="Layer_1" data-name="Layer 1">
            <path
                class="cls-2"
                d="M164.48,52.57A134.58,134.58,0,1,0,299.06,187.15,134.58,134.58,0,0,0,164.48,52.57Zm-.72,236.1A101.81,101.81,0,1,1,265.57,186.86,101.81,101.81,0,0,1,163.76,288.67Z"
                transform="translate(-29.89 -52.57)"
            />
            <path
                class="cls-3"
                d="M529.4,62.11c62.26,0,84.17,31.9,84.17,81.48s-22.29,81.47-84.17,81.47h-63v86.86H426v-206c0-30.74,13.06-43.81,43.81-43.81Zm-48,38.05c-10.38,0-15,4.23-15,14.6V187h63c34.21,0,43.82-14.22,43.82-43.43,0-28.83-10-43.43-43.82-43.43Z"
                transform="translate(-29.89 -52.57)"
            />
            <path
                class="cls-3"
                d="M785,254.66c0,42.27-25,61.49-81.87,61.49-50,0-78-18.45-78-59.19,0-43,30.37-58,78.41-58h42.27V180.1c0-23.83-18.06-29.21-45.35-29.21-22.67,0-42.27,2.69-54.57,7.3V123.6c13.84-4.61,31.51-6.53,52.27-6.53,51.88,0,86.86,15,86.86,63Zm-39.21-25.75H703.49c-26.14,0-38.82,7.68-38.82,27.29,0,22.67,18.06,26.51,37.66,26.51,25,0,43.43-3.84,43.43-30Z"
                transform="translate(-29.89 -52.57)"
            />
            <path
                class="cls-3"
                d="M862.2,311.92H822.62V191.63c0-47.28,26.13-74.56,83.78-74.56,60,0,83.4,26.52,83.4,74.56V311.92H950.21V191.63c0-24.21-7.3-37.67-43.81-37.67-36.13,0-44.2,13.46-44.2,37.67Z"
                transform="translate(-29.89 -52.57)"
            />
            <path
                class="cls-3"
                d="M1182,254.66c0,42.27-25,61.49-81.86,61.49-50,0-78-18.45-78-59.19,0-43,30.36-58,78.4-58h42.28V180.1c0-23.83-18.06-29.21-45.35-29.21-22.68,0-42.28,2.69-54.58,7.3V123.6c13.84-4.61,31.52-6.53,52.27-6.53,51.89,0,86.86,15,86.86,63Zm-39.2-25.75h-42.28c-26.13,0-38.81,7.68-38.81,27.29,0,22.67,18.06,26.51,37.66,26.51,25,0,43.43-3.84,43.43-30Z"
                transform="translate(-29.89 -52.57)"
            />
            <path
                class="cls-3"
                d="M1285.79,262.89c3.85,16.14,9.23,18.83,20.75,18.83,8.46,0,14.23-2.69,18.07-18.83l32.67-141h40.35L1351.9,312.47c-13.07,55-41.89,86.09-96.09,84.93l-8.07-34.2c39.59.77,55.35-20.76,63.8-50.35-4.22,1.92-11.14,2.69-17.68,2.69-31.13,0-39.2-20-46.5-49.19l-36.51-144.51h40.35Z"
                transform="translate(-29.89 -52.57)"
            />
            <path
                class="cls-3"
                d="M1570.11,254.66c0,42.27-25,61.49-81.87,61.49-50,0-78-18.45-78-59.19,0-43,30.36-58,78.41-58h42.27V180.1c0-23.83-18.06-29.21-45.35-29.21-22.67,0-42.28,2.69-54.57,7.3V123.6c13.83-4.61,31.51-6.53,52.27-6.53,51.88,0,86.86,15,86.86,63Zm-39.21-25.75h-42.27c-26.14,0-38.82,7.68-38.82,27.29,0,22.67,18.06,26.51,37.66,26.51,25,0,43.43-3.84,43.43-30Z"
                transform="translate(-29.89 -52.57)"
            />
        </g>
    </g>
</svg>
